import React, { useMemo } from 'react';
import _ from 'lodash';
import useTranslation from 'hooks/use-translation';

import { SidebarFiltersSection } from 'components/sidebar-filters';
import { CheckboxGroup, SearchBarFilter } from 'components/core';
import styled from 'styled-components';
import { useTerpenesFilter } from './use-terpenes-filter';
import { Terpenes } from './terpenes-filter.types';

type TerpenesFilterProps = {
  terpenes: Terpenes;
};

export function TerpenesFilter({ terpenes }: TerpenesFilterProps): JSX.Element {
  const { t } = useTranslation();
  const {
    terpenesFromQueryParams,
    terpeneOptionsToRender,
    handleTerpeneSelection,
    setSearch,
    search,
    displaySearchBar,
  } = useTerpenesFilter(terpenes);

  const terpeneOptions = terpeneOptionsToRender();

  const content = useMemo(() => {
    if (terpeneOptions.length === 0) {
      return <NoResults>No results</NoResults>;
    }

    return (
      <CheckboxGroup
        options={terpeneOptions}
        selectedOptions={terpenesFromQueryParams}
        onSelect={(terpene: string) => handleTerpeneSelection(_.kebabCase(terpene))}
      />
    );
  }, [terpeneOptions, terpenesFromQueryParams, handleTerpeneSelection]);

  return (
    <SidebarFiltersSection startsOpen heading={t('common.terpenes_plural', 'Terpenes')}>
      {displaySearchBar && (
        <SearchBarFilter
          placeholder={t('search-terpenes-placeholder', 'Search Terpenes...')}
          value={search}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearch(_.toLower(e.target.value))}
        />
      )}
      <>{content}</>
    </SidebarFiltersSection>
  );
}

const NoResults = styled.div`
  font-size: 13px;
  font-weight: 400;
  line-height: 1.125rem;
  margin-top: 0.75rem;
`;
